module.exports = __webpack_public_path__ + "static/img/karticakorisnika1.193baf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/tutorial/karticakorisnika1.png
// module id = QIES
// module chunks = 0